<script setup lang="ts">
import type { DailyPanelProps } from '@/ui/daily-panel'
import DailyPanel from './daily/DailyPanel.vue'
import DailyReadouts from './daily/DailyReadouts.vue'
import DailyChart from './daily/DailyChart.vue'
import DailyProgress from './daily/DailyProgress.vue'
import '@/ui/order-widget.css'
defineProps<DailyPanelProps>()
</script>
<template>
  <DailyPanel v-bind="$props" skin="daily-order">
    <DailyReadouts :data="data" :locale="locale" />
    <DailyChart :data="data" :locale="locale" />
    <DailyProgress :data="data" :locale="locale" />
    <template v-if="$slots.actions" #actions><slot name="actions" /></template>
  </DailyPanel>
</template>
